import { render, staticRenderFns } from "./QrShozoku.vue?vue&type=template&id=776e13d2"
import script from "./QrShozoku.vue?vue&type=script&lang=js"
export * from "./QrShozoku.vue?vue&type=script&lang=js"
import style0 from "./QrShozoku.vue?vue&type=style&index=0&id=776e13d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports